import { Component, OnInit } from '@angular/core';
import { UserService } from '../../Services/Users.service';
import { User } from '../../models/Users';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../Services/AuthGard.service';
import { GlobalService } from '../../Services/global.service';
import { until } from "selenium-webdriver";
import elementIsDisabled = until.elementIsDisabled;
import { TranslateService } from '@ngx-translate/core';
declare var $;
import * as CryptoJS from 'crypto-js';
import { CookieService } from "ngx-cookie-service";
import { Configuration } from "../../config/config";
import { CreateCommunityService } from '../../Services/create-community.service';
import * as jwt_decode from 'jwt-decode';
import * as moment from 'moment';
import { id } from '@swimlane/ngx-datatable/release/utils';
import { HttpUrlEncodingCodec, HttpClient } from '@angular/common/http';
import { isIP } from 'net';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [AuthService, CreateCommunityService]
})
export class LoginComponent implements OnInit {
  codec = new HttpUrlEncodingCodec;
  title: string = "Login User";
  users: User[];
  user: User;
  first_name: string;
  user_name: string;
  last_name: string;
  mail_id: string;
  phone: number;
  password: string;
  validationMsg: string;
  emailValidMsg: string;
  loginflag: boolean;
  privacy_protected: boolean;
  companyName: string;
  email_id: string;
  question: string;
  answer: string;
  communityName: string;
  recoverUser: boolean = false;
  email_managedby: boolean = false;
  byEmailRecovery: boolean = false;
  byUnameRecovery: boolean = true;
  emailProtected = true;
  noEmailProtected = true;
  recoverUsernameByName: boolean = false;
  color: string;
  receiver: string;
  AllCommunities = [];
  securityQuestions: Array<any> = [];
  loginStatusCode: any = "";
  alignorStstusCode: string = "";
  personalStstusCode: string = "";
  privacyField: boolean = false;
  uname_managedby: boolean = false;
  popupWindow = null;
  selectedGame = [];
  encodedUrl: string = '';
  buttonTitle: any;
  screenWidth: number = 1366;
  screenHeight: number;
  userExistData: any;
  userDataExistCode: any = '';
  securityQueStatusCode: any;
  login_attempt: number = 0;
  need_security_que_reset: boolean = true;
  security_que_attempt: number = 0;
  dontShowSecurityQueRadio: boolean;
  passwordType: boolean = false;
  securityQueFlag: boolean;
  showSSOBTN: boolean;
  showFrame: boolean = false;
  resAuth: any;
  socialBtDetails: any;
  showBulkSignup: boolean;
  encryptedToken: any;
  batchNametoken: string;
  batchIdSubDomain: any;
  showExpireMsg: boolean;
  expiry_date: string;
  groupRes: any;
  batchNameToken: any;
  abc: string;
  currentUsername: any;
  ipAddress: any;
  communityLogoUrl: string = '';

  constructor(private AuthService: AuthService, private http: HttpClient, private userService: UserService, private communityService: CreateCommunityService,
    private router: Router, private route: ActivatedRoute, private globalService: GlobalService, private translateService: TranslateService, private cookieService: CookieService) {
    localStorage.clear();
    sessionStorage.clear();
    var event = new CustomEvent("Show Header On Login", { "detail": "Example of an event" });
    document.dispatchEvent(event);

    let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;
    let lang_name = defaultLangData && defaultLangData.lang_name ? defaultLangData.lang_name : 'English';
    this.translateService.reloadLang(lang_name);
    /* let lang_name = 'English';
     this.translateService.reloadLang(lang_name);*/
  }

  ngOnInit() {
    this.abc = " ";
    localStorage.clear();
    sessionStorage.clear();
    let value;
    $(window).on('popstate', function () {
      location.reload();
    });

    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;

    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      } else {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      }
    });

    this.globalService.getTranslationTourHome();
    this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
      'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
      'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
      'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
      'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
        this.buttonTitle = label;
      });
    $('.modal-backdrop').css('display', 'none');
    this.encodedUrl = '';
    const ssoToken = this.route.snapshot.queryParams['token'];
    const urlId = this.route.snapshot.params['id'];
    const client_id = this.route.snapshot.params['client_id'];

    if (ssoToken) {
      value = ssoToken;
    } else if (urlId) {
      value = urlId;
    } else if (client_id) {
      value = client_id;
    }
    else {
      value = window.location.origin;
    }
    // alert(value);
    // alert(urlId);
    /* IDP login functionality start */
    if (client_id) {
      // alert('idp cognito');
      try {
        if (ssoToken) {
          this.resAuth = jwt_decode(value);
        } else {
          this.resAuth = value;
        }
        console.log("client id is here", client_id);
        if (client_id) {
          this.communityService.getCommunityByCommunityID(client_id).subscribe(clientIdRes => {
            this.checkForSSOAUTH(clientIdRes.community_id, clientIdRes.batch_id);
            let obj = {
              comm_id: clientIdRes.community_id,
            }
            console.log(clientIdRes, "clientId Result API response ");

            let current_date = moment().format("x");
            const client_id = this.route.snapshot.queryParams['client_id'];
            console.log("client_id", client_id);
            console.log("link is not expired");
            this.showExpireMsg = false;
            this.communityService.getDatafromCommunityID(obj)
              .subscribe(res => {
                if (res.success) {
                  if (this.resAuth.batch_id) {
                    let commResObj = {
                      community_id: res.data.comm_id,
                      community_name: res.data.comm_name,
                      batch_id: this.resAuth.batch_id
                    }
                    localStorage.setItem('CommResources', JSON.stringify(commResObj));
                  } else {
                    let commResObj = {
                      community_id: res.data.comm_id,
                      community_name: res.data.comm_name,
                    }
                    localStorage.setItem('CommResources', JSON.stringify(commResObj));
                  }
                  localStorage.setItem('authenticationType', res.data.authenticationType);

                  let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

                  let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
                  let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

                  this.globalService.setLang(lang_name);
                  this.globalService.setLangId(lang_id);

                  localStorage.setItem('defaultLangId', lang_id);
                  localStorage.setItem('defaultLang', lang_name);

                  this.translateService.use(lang_name);
                  this.translateService.reloadLang(lang_name);
                  this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
                    'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
                    'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
                    'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
                    'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
                      this.buttonTitle = label;
                    });
                  if (res.data.authenticationType === 'COGNITO_AUTHENTICATION') {

                    if (this.resAuth.batch_id) {
                      this.showBulkSignup = true;
                      //  this.showSSOBTN=false;
                    } else {
                      this.showBulkSignup = false;
                      this.showSSOBTN = true;
                    }
                    this.socialBtDetails = res.data.supportedIdps;

                    let user_pool = res.data.cognitoUserPool;
                  } else {
                    this.showSSOBTN = false;
                  }
                  //  this.cognitoUserPool = res.data.cognitoUserPool;
                }
                else {
                  console.log("Error...........2");
                }
              });
          })
        }


        this.translateService.get(['FREE_GAME_LINK_1', 'FREE_GAME_LINK_2']).subscribe(label => {
          this.selectedGame = label;
        });
      } catch (e) {
        console.log("err in sso  ==>", e);
        // Bugsnag.notify(e)
      }
    }
    /* IDP login functionality end */

    /* Normal cognito login functionality start */
    if (value != urlId) {
      // alert("Normal cognito login");
      try {
        if (ssoToken) {
          this.resAuth = jwt_decode(value);
        } else {
          this.resAuth = value;
        }
        const groupId = this.route.snapshot.queryParams['group_id'];
        
        console.log('result auth', this.resAuth);
        console.log("group id is here", groupId);
        if (this.resAuth.comm_id || this.resAuth.community_id) {
          this.checkForSSOAUTH(this.resAuth.comm_id ? this.resAuth.comm_id : this.resAuth.community_id, this.resAuth.batch_id);
          let obj = {
            comm_id: this.resAuth.comm_id ? this.resAuth.comm_id : this.resAuth.community_id,
          }
          console.log(this.resAuth, "resssssAuttthhh");

          let current_date = moment().format("x");
          const groupId = this.route.snapshot.queryParams['group_id'];
          console.log("GoupId", groupId);
          if (groupId != "") {
            this.userService.checkExpiryDate(groupId).subscribe(res => {
              this.groupRes = res;
              console.log("groupId details API response", res);
              console.log("expiry date of API response", res.data.expiry_date);
              this.expiry_date = res.data.expiry_date;
              // res.data
              if (current_date >= this.expiry_date) {
                this.showExpireMsg = true;
                console.log("link is expired");
                // $('#redirectLinkModel').modal('show');

              } else {
                console.log("link is not expired");
                this.showExpireMsg = false;
                this.communityService.getDatafromCommunityID(obj)
                  .subscribe(res => {
                    if (res.success) {
                      if (this.resAuth.batch_id) {
                        let commResObj = {
                          community_id: res.data.comm_id,
                          community_name: res.data.comm_name,
                          batch_id: this.resAuth.batch_id
                        }
                        localStorage.setItem('CommResources', JSON.stringify(commResObj));
                      } else {
                        let commResObj = {
                          community_id: res.data.comm_id,
                          community_name: res.data.comm_name,
                        }
                        localStorage.setItem('CommResources', JSON.stringify(commResObj));
                      }

                      // let commResObj = {
                      //   community_id: res.data.comm_id,
                      //   community_name: res.data.comm_name,
                      // };

                      // localStorage.setItem('CommResources', JSON.stringify(commResObj));
                      localStorage.setItem('authenticationType', res.data.authenticationType);

                      let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

                      let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
                      let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

                      this.globalService.setLang(lang_name);
                      this.globalService.setLangId(lang_id);

                      localStorage.setItem('defaultLangId', lang_id);
                      localStorage.setItem('defaultLang', lang_name);

                      this.translateService.use(lang_name);
                      this.translateService.reloadLang(lang_name);
                      this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
                        'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
                        'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
                        'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
                        'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
                          this.buttonTitle = label;
                        });
                      if (res.data.authenticationType === 'COGNITO_AUTHENTICATION') {

                        if (this.resAuth.batch_id) {
                          this.showBulkSignup = true;
                          //  this.showSSOBTN=false;
                        } else {
                          this.showBulkSignup = false;
                          this.showSSOBTN = true;
                        }
                        this.socialBtDetails = res.data.supportedIdps;

                        let user_pool = res.data.cognitoUserPool;

                      } else {
                        this.showSSOBTN = false;
                      }
                      //  this.cognitoUserPool = res.data.cognitoUserPool;
                    }
                    else {
                      console.log("Error...........2");
                    }
                  });
              }
            });
          }
          if (current_date >= this.expiry_date) {
            this.showExpireMsg = true;
            console.log("link is expired");
            // $('#redirectLinkModel').modal('show');

          } else {
            console.log("link is not expired");
            this.showExpireMsg = false;
            this.communityService.getDatafromCommunityID(obj)
              .subscribe(res => {
                if (res.success) {
                  if (this.resAuth.batch_id) {
                    let commResObj = {
                      community_id: res.data.comm_id,
                      community_name: res.data.comm_name,
                      batch_id: this.resAuth.batch_id
                    }
                    localStorage.setItem('CommResources', JSON.stringify(commResObj));
                  } else {
                    let commResObj = {
                      community_id: res.data.comm_id,
                      community_name: res.data.comm_name,
                    }
                    localStorage.setItem('CommResources', JSON.stringify(commResObj));
                  }

                  // let commResObj = {
                  //   community_id: res.data.comm_id,
                  //   community_name: res.data.comm_name,
                  // };

                  // localStorage.setItem('CommResources', JSON.stringify(commResObj));
                  localStorage.setItem('authenticationType', res.data.authenticationType);

                  let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

                  let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
                  let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

                  this.globalService.setLang(lang_name);
                  this.globalService.setLangId(lang_id);

                  localStorage.setItem('defaultLangId', lang_id);
                  localStorage.setItem('defaultLang', lang_name);

                  this.translateService.use(lang_name);
                  this.translateService.reloadLang(lang_name);
                  this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
                    'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
                    'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
                    'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
                    'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
                      this.buttonTitle = label;
                    });
                  if (res.data.authenticationType === 'COGNITO_AUTHENTICATION') {
                    console.log("cookie set");
                    this.cookieService.set("loginUrl",res.data.loginUrl);
                    if (this.resAuth.batch_id) {
                      this.showBulkSignup = true;
                      //  this.showSSOBTN=false;
                    } else {
                      this.showBulkSignup = false;
                      this.showSSOBTN = true;
                    }
                    this.socialBtDetails = res.data.supportedIdps;

                    let user_pool = res.data.cognitoUserPool;
                    //  this.userService.getSocialBtnFromUserPool(user_pool)
                    //  .subscribe(res =>{   
                    //    if (res.success){ 
                    //      console.log(res,"social media details");
                    //      this.socialBtDetails = res.data.supportedIdps;
                    //    }
                    //    else{
                    //      console.log("Error", res);
                    //    }
                    //  });  


                  } else {
                    this.showSSOBTN = false;
                    this.cookieService.delete("loginUrl","/");
                  }
                  //  this.cognitoUserPool = res.data.cognitoUserPool;
                }
                else {
                  console.log("Error...........2");
                }
              });
          }

        }
        // else {
        //   console.log("result auth contains", this.resAuth);
        //   let obj = {
        //     subDomainName: value,
        //   }
        //   const groupId = this.route.snapshot.queryParams['group_id'];

        //   if (groupId != "") {
        //     // alert("with group id");
        //     this.userService.checkExpiryDate(groupId).subscribe(res => {
        //       console.log("groupId details API response", res);
        //       const exp_date1 = res.data.expiry_date;
        //       const expiryDateSubDomian = res.data.expiry_date;
        //       this.batchNameToken = res.data.batch_id;

        //       let current_date = moment().format("x");
        //       let exp_date = expiryDateSubDomian;


        //       this.communityService.getDatafromCommunityID(obj)
        //         .subscribe(res => {
        //           if (res.success) {
        //             console.log(res, "for batch subdomain");
        //             localStorage.setItem('authenticationType', res.data.authenticationType);
        //             let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

        //             let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
        //             let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

        //             this.globalService.setLang(lang_name);
        //             this.globalService.setLangId(lang_id);

        //             localStorage.setItem('defaultLangId', lang_id);
        //             localStorage.setItem('defaultLang', lang_name);

        //             this.translateService.use(lang_name);
        //             this.translateService.reloadLang(lang_name);
        //             this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
        //               'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
        //               'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
        //               'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
        //               'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
        //                 this.buttonTitle = label;
        //               });

        //             if (res.data.authenticationType === 'COGNITO_AUTHENTICATION') {
        //               const batchNameToken = this.batchNameToken;
        //               // alert("cognito authentication");
        //               console.log("global array result", res);
        //               console.log("this batch name token", this.batchNameToken);
        //               console.log("batch name token", batchNameToken);
        //               console.log("expiry date token", expiryDateSubDomian);
        //               if (batchNameToken && !expiryDateSubDomian) {
        //                 this.userService.getBatchIdFromBatchNameSSO(res.data.comm_id, batchNameToken)
        //                   .subscribe(result => {
        //                     if (result.success) {
        //                       this.batchIdSubDomain = result.data.batch_id;

        //                       if (this.resAuth.batch_id || this.batchIdSubDomain) {
        //                         let commResObj = {
        //                           community_id: res.data.comm_id,
        //                           community_name: res.data.comm_name,
        //                           batch_id: this.resAuth.batch_id || this.batchIdSubDomain
        //                         }
        //                         localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                         this.showBulkSignup = true;
        //                         //  this.showSSOBTN=false;
        //                       } else {
        //                         let commResObj = {
        //                           community_id: res.data.comm_id,
        //                           community_name: res.data.comm_name,
        //                         }
        //                         localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                         this.showBulkSignup = false;
        //                         this.showSSOBTN = true;
        //                       }
        //                     }
        //                     else {
        //                       console.log("Error");
        //                     }
        //                   });
        //               }
        //               else if (batchNameToken && expiryDateSubDomian) {

        //                 console.log("result data", this.resAuth);
        //                 if (current_date >= exp_date) {
        //                   this.showExpireMsg = true;
        //                   // alert("link is expired");
        //                 } else {
        //                   this.showExpireMsg = false;
        //                   // alert(res.data.comm_id);
        //                   // alert(batchNameToken);
        //                   this.userService.getBatchIdFromBatchNameSSO(res.data.comm_id, batchNameToken)
        //                     .subscribe(result => {
        //                       // alert("Api called");
        //                       console.log("getBatchIdFromBatchNameSSO Api response", result);
        //                       // if (result.success) {
        //                       this.batchIdSubDomain = batchNameToken;
        //                       if (this.resAuth.batch_id || this.batchIdSubDomain) {
        //                         let commResObj = {
        //                           community_id: res.data.comm_id,
        //                           community_name: res.data.comm_name,
        //                           batch_id: this.batchIdSubDomain
        //                         }
        //                         localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                         this.showBulkSignup = true;
        //                         //  this.showSSOBTN=false;
        //                       } else {
        //                         let commResObj = {
        //                           community_id: res.data.comm_id,
        //                           community_name: res.data.comm_name,
        //                         }
        //                         localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                         this.showBulkSignup = false;
        //                         this.showSSOBTN = true;
        //                       }
        //                       // }
        //                       // else {
        //                       //   console.log("Error");
        //                       // }
        //                     });
        //                 }
        //               } else {
        //                 console.log("Error");
        //                 // alert("error");
        //               }

        //               if (this.batchIdSubDomain) {
        //                 let commResObj = {
        //                   community_id: res.data.comm_id,
        //                   community_name: res.data.comm_name,
        //                   batch_id: this.batchIdSubDomain
        //                 }
        //                 localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                 this.showBulkSignup = true;
        //                 //  this.showSSOBTN=false;
        //               } else {
        //                 let commResObj = {
        //                   community_id: res.data.comm_id,
        //                   community_name: res.data.comm_name,
        //                 }
        //                 localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                 this.showBulkSignup = false;
        //                 this.showSSOBTN = true;
        //               }
        //               this.socialBtDetails = res.data.supportedIdps;
        //               // alert(this.socialBtDetails.buttonText);
        //               let user_pool = res.data.cognitoUserPool;

        //             } else {
        //               this.showSSOBTN = false;
        //             }
        //             //  this.cognitoUserPool = res.data.cognitoUserPool;
        //           }
        //           else {
        //             console.log("Error...........2");
        //           }
        //         });
        //     });
        //   }
        //   const batchNameToken = this.route.snapshot.queryParams.batch_name;
        //   const expiryDateSubDomian = this.route.snapshot.queryParams.expiry_date;

        //   let current_date = moment().format("x");
        //   let exp_date = expiryDateSubDomian;
        //   this.communityService.getDatafromCommunityID(obj)
        //     .subscribe(res => {
        //       if (res.success) {
        //         console.log(res, "for batch subdomain");

        //         localStorage.setItem('authenticationType', res.data.authenticationType);
        //         let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

        //         let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
        //         let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

        //         this.globalService.setLang(lang_name);
        //         this.globalService.setLangId(lang_id);

        //         localStorage.setItem('defaultLangId', lang_id);
        //         localStorage.setItem('defaultLang', lang_name);

        //         this.translateService.use(lang_name);
        //         this.translateService.reloadLang(lang_name);
        //         this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
        //           'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
        //           'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
        //           'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
        //           'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
        //             this.buttonTitle = label;
        //           });

        //         if (res.data.authenticationType === 'COGNITO_AUTHENTICATION') {
        //           if (batchNameToken && !expiryDateSubDomian) {
        //             this.userService.getBatchIdFromBatchNameSSO(res.data.comm_id, batchNameToken)
        //               .subscribe(result => {
        //                 if (result.success) {
        //                   this.batchIdSubDomain = result.data.batch_id;

        //                   if (this.resAuth.batch_id || this.batchIdSubDomain) {
        //                     let commResObj = {
        //                       community_id: res.data.comm_id,
        //                       community_name: res.data.comm_name,
        //                       batch_id: this.resAuth.batch_id || this.batchIdSubDomain
        //                     }
        //                     localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                     this.showBulkSignup = true;
        //                     //  this.showSSOBTN=false;
        //                   } else {
        //                     let commResObj = {
        //                       community_id: res.data.comm_id,
        //                       community_name: res.data.comm_name,
        //                     }
        //                     localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                     this.showBulkSignup = false;
        //                     this.showSSOBTN = true;
        //                   }
        //                 }
        //                 else {
        //                   console.log("Error");
        //                 }
        //               });
        //           }
        //           else if (batchNameToken && expiryDateSubDomian) {
        //             if (current_date >= exp_date) {
        //               this.showExpireMsg = true;
        //             } else {
        //               this.showExpireMsg = false;
        //               this.userService.getBatchIdFromBatchNameSSO(res.data.comm_id, batchNameToken)
        //                 .subscribe(result => {
        //                   if (result.success) {
        //                     this.batchIdSubDomain = result.data.batch_id;
        //                     if (this.resAuth.batch_id || this.batchIdSubDomain) {
        //                       let commResObj = {
        //                         community_id: res.data.comm_id,
        //                         community_name: res.data.comm_name,
        //                         batch_id: this.resAuth.batch_id || this.batchIdSubDomain
        //                       }
        //                       localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                       this.showBulkSignup = true;
        //                       //  this.showSSOBTN=false;
        //                     } else {
        //                       let commResObj = {
        //                         community_id: res.data.comm_id,
        //                         community_name: res.data.comm_name,
        //                       }
        //                       localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //                       this.showBulkSignup = false;
        //                       this.showSSOBTN = true;
        //                     }
        //                   }
        //                   else {
        //                     console.log("Error");
        //                   }
        //                 });
        //             }
        //           } else {
        //             console.log("Error");
        //           }

        //           if (this.resAuth.batch_id || this.batchIdSubDomain) {
        //             let commResObj = {
        //               community_id: res.data.comm_id,
        //               community_name: res.data.comm_name,
        //               batch_id: this.resAuth.batch_id || this.batchIdSubDomain
        //             }
        //             localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //             this.showBulkSignup = true;
        //             //  this.showSSOBTN=false;
        //           } else {
        //             let commResObj = {
        //               community_id: res.data.comm_id,
        //               community_name: res.data.comm_name,
        //             }
        //             localStorage.setItem('CommResources', JSON.stringify(commResObj));
        //             this.showBulkSignup = false;
        //             this.showSSOBTN = true;
        //           }
        //           this.socialBtDetails = res.data.supportedIdps;
        //           let user_pool = res.data.cognitoUserPool;

        //         } else {
        //           this.showSSOBTN = false;
        //         }
        //         //  this.cognitoUserPool = res.data.cognitoUserPool;
        //       }
        //       else {
        //         console.log("Error...........2");
        //       }
        //     });
        // }
        this.translateService.get(['FREE_GAME_LINK_1', 'FREE_GAME_LINK_2']).subscribe(label => {
          this.selectedGame = label;
        });
      } catch (e) {
        console.log("err in sso  ==>", e);
        // Bugsnag.notify(e)
      }
    }
    /* Normal cognito login functionality end */

    /* batchid login functionality start */
    if (value == urlId) {
      // alert('batch id url')
      let dec = window.atob(value);
      console.log(dec);
      if (dec && dec.includes('communityID')) {
        let obj = JSON.parse(dec);
        obj.communityID = obj.communityID ? obj.communityID.trim() : '';
        if (obj && obj.communityID) {
          this.encodedUrl = value;
          this.userService.getCommunityNameByCommunityID(obj.communityID).subscribe(comm => {
            let commResObj = {
              community_id: comm.data.comm_id,
              community_name: comm.data.comm_name,
              resource_config: comm.data.resource_config,
              batch_id: comm.data.batchId,
            };

            localStorage.setItem('CommResources', JSON.stringify(commResObj));


            let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

            let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
            let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

            this.globalService.setLang(lang_name);
            this.globalService.setLangId(lang_id);

            localStorage.setItem('defaultLangId', lang_id);
            localStorage.setItem('defaultLang', lang_name);

            this.translateService.use(lang_name);
            this.translateService.reloadLang(lang_name);
            this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
              'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
              'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
              'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
              'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
                this.buttonTitle = label;
              });

            if (comm.success && comm.data) {
              this.userService.getCommunityLogo(obj.communityID).subscribe(res => {
                let ob = { communityID: comm.data.comm_id };
                let gObj = {
                  id: window.btoa(JSON.stringify(ob)),
                  communityName: comm.data.comm_name,
                  communityID: comm.data.comm_id,
                  purpose: "login",
                  image_data: res.data.image_data
                };
                this.globalService.isLoginComm = gObj;
                this.userService.isCommunity = window.btoa(JSON.stringify(ob));
                let comObj = {
                  communityName: comm.data.comm_name,
                  communityID: comm.data.comm_id,
                  purpose: "login"
                };
                this.getclientData(window.btoa(JSON.stringify(comObj)));
              });
            }
          });
        } else {
          let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

          let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
          let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

          this.globalService.setLang(lang_name);
          this.globalService.setLangId(lang_id);

          localStorage.setItem('defaultLangId', lang_id);
          localStorage.setItem('defaultLang', lang_name);

          this.translateService.use(lang_name);
          this.translateService.reloadLang(lang_name);
          this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
            'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
            'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
            'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
            'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
              this.buttonTitle = label;
            });
          this.globalService.isLoginComm = {
            id: null,
            communityName: null,
            communityID: null,
            purpose: null,
            image_data: null
          };
          this.userService.isCommunity = null;
          this.getclientData(null);
        }
      } else {
        let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

        let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
        let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

        this.globalService.setLang(lang_name);
        this.globalService.setLangId(lang_id);

        localStorage.setItem('defaultLangId', lang_id);
        localStorage.setItem('defaultLang', lang_name);

        this.translateService.use(lang_name);
        this.translateService.reloadLang(lang_name);
        this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
          'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
          'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
          'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
          'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
            this.buttonTitle = label;
          });
        this.globalService.isLoginComm = {
          id: null,
          communityName: null,
          communityID: null,
          purpose: null,
          image_data: null
        };
        this.userService.isCommunity = null;
        this.getclientData(null);
      }
    }
    /* batchid login functionality end */

    /* Normal  login functionality start */
    else {
      // alert("Normal alignor login")
      let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

      let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
      let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

      this.globalService.setLang(lang_name);
      this.globalService.setLangId(lang_id);

      localStorage.setItem('defaultLangId', lang_id);
      localStorage.setItem('defaultLang', lang_name);

      this.translateService.use(lang_name);
      this.translateService.reloadLang(lang_name);
      this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
        'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
        'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
        'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
        'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
          this.buttonTitle = label;
        });

      this.globalService.isLoginComm = {
        id: null,
        communityName: null,
        communityID: null,
        purpose: null,
        image_data: null
      };
      this.userService.isCommunity = null;
      this.getclientData(null);
    }
    /* Normal  login functionality end */

    // In a real app: dispatch action to load the details here.
    this.translateService.get(['FREE_GAME_LINK_1', 'FREE_GAME_LINK_2']).subscribe(label => {
      this.selectedGame = label;
    });
    
    // Load community logo
    this.loadCommunityLogo();
    // });
  }

  loadCommunityLogo() {
    const ssoToken = this.route.snapshot.queryParams['token'];
    const urlId = this.route.snapshot.params['id'];
    const client_id = this.route.snapshot.params['client_id'];
    let communityId = null;

    // Try to get from query param token first
    if (ssoToken) {
      try {
        const decoded = jwt_decode(ssoToken);
        communityId = decoded['communityID'] || decoded['comm_id'] || decoded['community_id'];
        console.log('Decoded community ID from ssoToken:', communityId);
      } catch (e) {
        console.log('Error decoding ssoToken:', e);
      }
    }

    // Try URL param id
    if (!communityId && urlId) {
      try {
        const decoded = jwt_decode(urlId);
        communityId = decoded['communityID'] || decoded['comm_id'];
        console.log('Decoded community ID from urlId:', communityId);
      } catch (e) {
        communityId = urlId;
        console.log('Using urlId directly as community ID:', communityId);
      }
    }
    
    // Try client_id
    if (!communityId && client_id) {
      communityId = client_id;
      console.log('Using client_id as community ID:', communityId);
    }

    // Try localStorage CompanyData
    if (!communityId) {
      const companyData = localStorage.getItem('CompanyData');
      if (companyData) {
        try {
          const parsed = JSON.parse(companyData);
          communityId = parsed.communityID;
          console.log('Community ID from CompanyData:', communityId);
        } catch (e) {
          console.log('Error parsing CompanyData:', e);
        }
      }
    }

    // Try localStorage CommResources
    if (!communityId) {
      const commResources = localStorage.getItem('CommResources');
      console.log('CommResources from localStorage:', commResources);
      if (commResources) {
        try {
          const parsed = JSON.parse(commResources);
          communityId = parsed.community_id;
          console.log('Community ID from CommResources:', communityId);
        } catch (e) {
          console.log('Error parsing CommResources:', e);
        }
      }
    }

    console.log('Final communityId:', communityId);

    if (communityId && communityId !== 'global') {
      console.log('Calling getCommunityLogo for community:', communityId);
      this.userService.getCommunityLogo(communityId).subscribe(
        (res: any) => {
          console.log('getCommunityLogo response:', res);
          if (res && res.data && res.data.image_data) {
            console.log('Image data received, length:', res.data.image_data.length);
            this.communityLogoUrl = 'data:image/png;base64,' + res.data.image_data;
            $(".sldier-logo").attr('src', "data:image/png;base64," + res.data.image_data);
            console.log('Logo set successfully via jQuery');
          } else {
            console.log('No image data in response');
          }
          $("#preloader").css('display', 'none');
        },
        (error) => {
          console.error('Error fetching community logo:', error);
          $("#preloader").css('display', 'none');
        }
      );
    } else {
      console.log('Not loading logo - communityId is:', communityId);
      $("#preloader").css('display', 'none');
    }
  }

  closeSelectionModal(userType: any) {
    let current_user = JSON.parse(localStorage.getItem('currentUser'));
    const userRole = this.codec.encodeValue(current_user.user.role);
    const cleanUserRole = userRole.replace(/%20/g, ' ').trim();
    if (userRole == "Manager") {
      $('#dashboardSelection').modal('hide');
      this.router.navigate(['/dashboard/learner/learnerDashboard']);
    } else if (cleanUserRole == "admin") {
      $('#adminDashboardSelection').modal('hide');
      $("#preloader").css('display', 'block');
      this.router.navigate(['/dashboard/portal/portalDashboard']);
    } else if (cleanUserRole == "Community Admin") {
      if (current_user.user.question != "") {
        this.userService
          .getCommunityByCommunityID(current_user.user.community_id)
          .subscribe((res) => {
            localStorage.setItem(
              "activationStatus",
              res.data.activation_status
            );
            localStorage.setItem(
              "certificateManagement",
              res.data.config[0].certficate_mgmt
            );
            sessionStorage.setItem("loginPage", "yes");
            $("#preloader").css("display", "none");
            // $('#dashboardSelection').modal('show');
            this.router.navigate(["/dashboard/portal/communityDashboard"]);
          });
      } else {
        this.router.navigate(["/communityUser"]);
      }
    }
  }

  // redirectLogin() {

  //   let obj = {
  //     comm_id: this.resAuth.comm_id ? this.resAuth.comm_id : this.resAuth.community_id,
  //   }

  //   this.communityService.getDatafromCommunityID(obj)
  //     .subscribe(res => {

  //       $('#redirectLinkModel').modal('hide');
  //       if (res.data.authenticationType === 'COGNITO_AUTHENTICATION') {
  //         //       // this.redirectURL = res.data.loginUrl;

  //         // this.router.navigate(["/login"],{ queryParams: {token: res.data.loginUrl}});
  //         location.href = window.location.origin + "/login?token=" + res.data.loginUrl;

  //       }
  //       else {

  //         this.router.navigate(["/login"]);
  //       }

  //     })

  // }

  loginUser(signForm) {

    $("#preloader").css('display', 'block');
    var signinObj = {
      user_name: this.user_name.toLocaleLowerCase(),
      password: this.password
    };

    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(signinObj), '#Alignor Credentials#').toString();
    let authentication = {
      authentication: ciphertext
    }
    console.log("input for login API", signinObj);
    this.AuthService.login(authentication)
      .subscribe(sign => {
        var resobj = JSON.parse(sign._body);

        this.validationMsg = resobj.message;
        this.loginStatusCode = resobj.statusCode;
        if (resobj.success) {
          let current_user = JSON.parse(localStorage.getItem('currentUser'));

          let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

          let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
          // let lang_name = resobj.data.defaultLang ? resobj.data.defaultLang : 'English';

          // let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
          const usrRole = localStorage.getItem('userRole');
          if (usrRole == "Alignor Admin" || usrRole == "Game Author" || usrRole == "Translator") {
            this.cookieService.delete('defaultLangData', '/');
            lang_name = 'English';
            let customObject = {
              lang_id: "English",
              lang_name: "English"
            };
            let jsonString = JSON.stringify(customObject);
            this.cookieService.set('defaultLangData', jsonString, 365, '/');
          }
          this.translateService.reloadLang(lang_name);

          localStorage.setItem('Volume', '0.5');

          if (current_user.user.community_user == true) {
            this.router.navigate(['/communityUser']);
          } else if (current_user.user.community_user == false) {
            const Role:any = localStorage.getItem('userRole');

            const details = {
              userName: current_user.user.username,
              screenResolution: this.globalService.getCurrentScreenResolution(),
              browserName: this.globalService.getCurrentBrowserName(),
              isCacheDisabled: false
            };

            //this.globalService.saveUsersLoginDetails(details).subscribe(res => {});

            if (Role == 'Alignor Admin') {
              if (current_user.user.question != "") {
                // $("#preloader").css('display', 'none');
                // $('#adminDashboardSelection').modal('show');
                this.router.navigate(['/dashboard/portal/portalDashboard']);
              } else {
                this.router.navigate(['/communityUser']);
              }
            } else if (Role == 'Community Admin') {
              if (current_user.user.question != "") {
                this.userService.getCommunityByCommunityID(resobj.data.community_id).subscribe(res => {
                  localStorage.setItem("activationStatus", res.data.activation_status);
                  localStorage.setItem("certificateManagement", res.data.config[0].certficate_mgmt);
                  sessionStorage.setItem('loginPage', 'yes');
                  $("#preloader").css('display', 'none');
                  $('#dashboardSelection').modal('show');
                  // this.router.navigate(['/dashboard/portal/communityDashboard']);
                });
              } else {
                this.router.navigate(['/communityUser']);
              }
            } else if (Role == 'Learner' || Role == 'Manager') {
              let LangData = this.cookieService.get('changeLanguage') ? JSON.parse(this.cookieService.get('changeLanguage')) : "English";
              console.log(LangData, "LangData");
              let lang_id;
              if (LangData.isChangeLang) {
                lang_name = LangData.lang_name ? LangData.lang_name : 'English';
                lang_id = LangData.lang_id ? LangData.lang_id : 'English';
              } else {
                lang_name = resobj.data.defaultLang ? resobj.data.defaultLang : 'English';

                this.userService.getAllLanguage().subscribe(lang => {
                  if (lang.success) {
                    for (var i = 0; i < lang.data.length; i++) {
                      if (lang.data[i].lang_name === lang_name) {
                        lang_id = lang.data[i].language_id;
                        console.log(lang_id, "lang_id======>login");
                      }
                    }
                    localStorage.setItem('defaultLangId', lang_id);
                  }
                });
                localStorage.setItem('defaultLang', lang_name);
              }
              if (Role == 'Manager' || Role == 'Community Admin' || Role == 'Admin') {
                localStorage.setItem('guideVideoSeenStatus', 'true');

                this.globalService.getTranslationTour();
                sessionStorage.setItem('loginPage', 'yes');
                $("#preloader").css('display', 'none');
                $('#dashboardSelection').modal('show');

                // this.router.navigate(['/dashboard/learner/learnerDashboard']);
              } else {
                this.router.navigate(['/dashboard/learner/learnerDashboard']);
                localStorage.setItem('guideVideoSeenStatus', 'true');
                this.globalService.getTranslationTour();
                sessionStorage.setItem('loginPage', 'yes');
              }



            } else if (Role == 'Game Author') {
              if (current_user.user.question != "") {
                this.router.navigate(['/dashboard/portal/spriteAnimation']);
              } else {
                this.router.navigate(['/communityUser']);
              }
            } else if (Role == 'Translator') {
              if (current_user.user.question != "") {
                this.router.navigate(['/dashboard/portal/gameTranslate']);
              } else {
                this.router.navigate(['/communityUser']);
              }
            }
          }

          // Company Data
          const CompanyData = JSON.parse(localStorage.getItem('CompanyData'));
          if (CompanyData && CompanyData.communityID && CompanyData.communityID != 'global' && CompanyData.communityID != resobj.data.community_id) {
            this.globalService.isLoginComm = {
              id: null,
              communityName: null,
              communityID: null,
              purpose: null,
              image_data: null
            };
            this.getclientData(null);
          }
        } else {
          $("#preloader").css('display', 'none');
          signForm.reset();
          $("#user_name").focus();
          this.loginflag = false;
          if (this.loginStatusCode == 203) {
            $('#passwordResetRequiredModal').modal();
          }
          if (this.loginStatusCode == 204) {
            $('#passwordResetRequiredModal').modal();
          }
        }
      });
  }

  addNewUserRedirect() {
    this.loginStatusCode = "";
    this.alignorStstusCode = "";
    this.personalStstusCode = "";
    if (this.encodedUrl && this.encodedUrl.length > 0) {
      this.router.navigate(['/RegisterUser/' + this.encodedUrl]);
    } else {
      this.router.navigate(['/RegisterUser']);
    }
  }

  redirectToManagerPortal(userType: any) {
    if (userType == "manager") {
      let current_user = JSON.parse(localStorage.getItem('currentUser'));
      console.log("current_user", current_user);
      this.currentUsername = current_user.user.username;
      $('#dashboardSelection').modal('hide');
      const communityIdForManager = this.codec.encodeValue(current_user.user.community_id);
      const userNameForManager = this.codec.encodeValue(current_user.user.username);
      const clientKeyForManager = this.codec.encodeValue(current_user.user.client_id);
      const clientTokenForManager = this.codec.encodeValue(current_user.token);
      const community_username_type = this.codec.encodeValue(current_user.community_username_type);
      const token = this.codec.encodeValue(current_user.token);
      const userType = this.codec.encodeValue(current_user.user.role);
      let obj = {
        "c_id": communityIdForManager,
        "uname": userNameForManager,
        "ckey": clientKeyForManager,
        "i_addr": this.ipAddress,
        "community_username_type":community_username_type,
        "token":token,
        "userType": userType
      }
      // this.cookieService.set("skelObj",JSON.stringify(obj));
      this.cookieService.set("skelObj", JSON.stringify(obj), undefined, '/', '.alignorgames.com', false);
        this.ipAddress = "res.ip";
        const managerPortalUrl = Configuration.ManagerBaseURL + "dashboard";
        window.location.href = managerPortalUrl;

    } else if (userType == "admin") {
      var set1 = ";,/?:@&=+$";
      let current_user = JSON.parse(localStorage.getItem('currentUser'));
      console.log("current_user", current_user);
      this.currentUsername = current_user.user.username;
      $('#adminDashboardSelection').modal('hide');
      const communityIdForManager = current_user.user.community_id;
      const userNameForManager = current_user.user.username;
      const clientKeyForManager = "7A2ezrVZJ5kk1c41cv43v";
      // this.http.get("http://api.ipify.org/?format=json").subscribe((res: any) => {
        this.ipAddress = "res.ip";
        const managerPortalUrl =  "?communityIdForManager=" +encodeURIComponent(communityIdForManager) + "&userNameForManager=" + encodeURIComponent(userNameForManager) + "&clientKeyForManager=" + encodeURIComponent(clientKeyForManager) + "&userType=admin" + "&ipAddress="+ encodeURIComponent(this.ipAddress);
        // let url = encodeURI(managerPortalUrl,set1)
        window.location.href = Configuration.ManagerBaseURL + "/dashboard/learner-dashboard"+ managerPortalUrl;
      // });
    }else if (userType == "Community Admin") {
      var set1 = ";,/?:@&=+$";
      let current_user = JSON.parse(localStorage.getItem('currentUser'));
      console.log("current_user", current_user);
      this.currentUsername = current_user.user.username;
      $('#adminDashboardSelection').modal('hide');
      const communityIdForManager = current_user.user.community_id;
      const userNameForManager = current_user.user.username;
      const clientKeyForManager = "7A2ezrVZJ5kk1c41cv43v";
      // this.http.get("http://api.ipify.org/?format=json").subscribe((res: any) => {
        this.ipAddress = "res.ip";
        const managerPortalUrl =  "?communityIdForManager=" +encodeURIComponent(communityIdForManager) + "&userNameForManager=" + encodeURIComponent(userNameForManager) + "&clientKeyForManager=" + encodeURIComponent(clientKeyForManager) + "&userType=admin" + "&ipAddress="+ encodeURIComponent(this.ipAddress);
        // let url = encodeURI(managerPortalUrl,set1)
        window.location.href = Configuration.ManagerBaseURL + "/dashboard/learner-dashboard"+ managerPortalUrl;
      // });
    }

  }

  getclientData(id: any) {

    this.userService.getClientData(id)
      .subscribe(result => {

        if (result == '' || result == null) {
        } else {
          this.companyName = result.data.communityName;
          if (this.companyName == 'None') {
            this.recoverUser = true;
          } else {
            this.recoverUser = false;
          }

          localStorage.setItem('CompanyData', JSON.stringify(result.data));
          if (result.data.purpose == 'register') {
            this.router.navigate(['/RegisterUser']);
          } else {
            var communityID;
            const theCommunity = JSON.parse(localStorage.getItem('CompanyData'));
            if (theCommunity) {
              communityID = theCommunity.communityID;
            } else {
              communityID = 'global';
            }
            if (communityID) {
              this.userService.getCommunityByCommunityID(communityID)
                .subscribe(community => {
                  if (community.success) {
                    if (community.data) {
                      if (community.data.privacy_protected) {
                        this.privacyField = false;
                      } else {
                        this.privacyField = true;
                      }
                    }
                  }
                });
            }
          }
        }
      });
  }

  mailsend(mailForm) {
    $("#preloaderModal").css('display', 'block');

    var mailObj = {
      email_id: this.email_id,
      user_name: this.user_name.toLowerCase(),
      isIsolated: false
    };

    this.userService.sendmaillink(mailObj)
      .subscribe(data => {
        this.userService.setSeqQues(this.user_name.toLowerCase(), false).
          subscribe(res => { console.log(res) });
        $("#preloaderModal").css('display', 'none');
        this.personalStstusCode = data.statusCode;
        if (data.success) {
          this.emailValidMsg = data.message;
          this.color = 'green';
          if (mailForm) {
            mailForm.reset();
          }


          setTimeout(() => {
            $('#myModal').modal('hide');
            this.personalStstusCode = "";
            this.receiver = undefined;
            // this.question = undefined;
          }, 1500);
        } else {
          this.emailValidMsg = data.message;
          this.color = 'red';
        }
      }
      );
  }

  emailOption(e, form) {
    // if (form) {
    //   form.reset();
    // }
    this.uname_managedby = false;
    this.email_managedby = true;

    this.byUnameRecovery = true;
    this.byEmailRecovery = false;
    this.email_id = this.userExistData.mail_id;
    // this.user_name = "";
    this.password = "";
    this.answer = "";
    this.emailValidMsg = '';
    this.alignorStstusCode = '';
    setTimeout(() => {
      this.receiver = undefined;
      // this.question = undefined;
    }, 100);
  }

  usernameOption(e, form) {
    // if (form) {
    //   form.reset();
    // }

    this.uname_managedby = true;
    this.email_managedby = false;

    this.byEmailRecovery = true;
    this.byUnameRecovery = false;
    this.emailValidMsg = '';
    this.email_id = this.userExistData.mail_id;
    // this.user_name = "";
    this.password = "";
    this.personalStstusCode = "";
    this.answer = "";
    setTimeout(() => {
      this.receiver = undefined;
      // this.question = undefined;
    }, 100);
  }

  mailsendAlignor(mailsendAlignorForm) {

    let ind = this.securityQuestions.findIndex(obj => obj.que == this.question);
    if (ind > -1) {
      console.log('Question');
      let mailObj = {
        user_name: this.user_name.toLowerCase(),
        question_id: this.securityQuestions[ind].que_id,
        question: this.question,
        answer: this.answer
      };

      this.userService.sendmailAlignorlink(mailObj)
        .subscribe(data => {
          console.log(data);
          this.userService.setSeqQues(this.user_name.toLowerCase(), true).
            subscribe(res => { console.log(res) });

          this.alignorStstusCode = data.statusCode;
          this.securityQueStatusCode = data.statusCode;
          if (data.success) {
            if (data.isprivacyprotected) {
              this.emailValidMsg = data.message;
              this.color = 'green';
              mailsendAlignorForm.reset();

              setTimeout(() => {
                $('#myModal').modal('hide');
                this.alignorStstusCode = "";
                this.receiver = undefined;
                // this.question = undefined;
              }, 1500);
            } else {
              this.alignorStstusCode = "";
              $('#myModal').modal('hide');
              this.router.navigate([data.redirect_URL]);
            }
          } else {
            this.emailValidMsg = data.message;
            this.color = 'red';
            if (this.securityQueStatusCode == 203) {
              if (this.email_id) {
                this.mailsend('');
                $('#securityQueResetModal').modal();
              } else {
                this.securityAttemptMailToAdmin();
              }

            }
          }
        }
        );
    } else {
      let mailObj = {
        user_name: this.user_name.toLowerCase(),
        question_id: '',
        question: this.question,
        answer: this.answer
      };

      this.userService.sendmailAlignorlink(mailObj)
        .subscribe(data => {
          this.alignorStstusCode = data.statusCode;
          this.securityQueStatusCode = data.statusCode;
          if (data.success) {
            if (data.isprivacyprotected) {
              this.emailValidMsg = data.message;
              this.color = 'green';
              mailsendAlignorForm.reset();

              setTimeout(() => {
                $('#myModal').modal('hide');
                this.alignorStstusCode = "";
                this.receiver = undefined;
                // this.question = undefined;
              }, 1500);
            } else {
              this.alignorStstusCode = "";
              $('#myModal').modal('hide');
              this.router.navigate([data.redirect_URL]);
            }
          } else {
            this.emailValidMsg = data.message;
            this.color = 'red';
            if (this.securityQueStatusCode == 203) {
              if (this.email_id) {
                this.mailsend('');
                $('#securityQueResetModal').modal();
              } else {
                this.securityAttemptMailToAdmin();
              }

            }
          }
        }
        );
    }
  }

  closeModel(mailForm, mailsendAlignorForm) {
    if (mailForm) {
      mailForm.reset();
    }
    if (mailsendAlignorForm) {
      mailsendAlignorForm.reset();
    }

    // this.question = undefined;

    this.user_name = "";
    this.password = "";
    this.personalStstusCode = "";
    this.alignorStstusCode = "";
    this.userDataExistCode = '';
    this.byEmailRecovery = false;
    this.byUnameRecovery = true;
    this.uname_managedby = false;
    this.email_managedby = false;
    $('#deafultMail').prop('checked', true);
  }

  clearValidation(txt) {
    $('#passwordResetRequiredModal').modal('hide');
    this.emailValidMsg = "";
    this.loginStatusCode = "";
    this.uname_managedby = false;
    this.email_managedby = false;
    this.userDataExistCode = '';

    if (txt == 'USERNAME') {
      this.userService.getAllProtectedCommunity()
        .subscribe(comm => {
          if (comm.success) {
            this.AllCommunities = comm.data;
          }
        });
    } else if (txt == 'PASSWORD') {
      let lang_id = this.globalService.getLangId();
      this.userService.getSecurityQuestions(lang_id)
        .subscribe(questions => {
          if (questions.success) {
            this.securityQuestions = questions.data;
          }
        });
    }

    setTimeout(() => {
      this.receiver = undefined;
      // this.question = undefined;
    }, 100);
  }
  // Show modal popup on Keyboard Enter
  enterPwdTab(e) {
    $('#passwordResetRequiredModal').modal('hide');
    if (e.keyCode == 13) {
      let lang_id = this.globalService.getLangId();
      this.userService.getSecurityQuestions(lang_id)
        .subscribe(questions => {
          if (questions.success) {
            this.securityQuestions = questions.data;

            $("#myModal").modal('show');
          }
        });
    }
  }
  enterUserTab(e) {
    if (e.keyCode == 13) {
      this.userService.getAllProtectedCommunity()
        .subscribe(comm => {
          if (comm.success) {
            this.AllCommunities = comm.data;
            $("#userModal").modal('show');
          }
        });
    }
  }

  usersend(userForm) {
    if (this.recoverUsernameByName) {

      const mailObj = {
        first_name: this.first_name,
        last_name: this.last_name,
        communityId: this.receiver,
        communityName: this.communityName
      };

      if (this.first_name.length > 0 && this.last_name.length > 0) {

        this.userService.unameRecoveryToAlignor(mailObj)
          .subscribe(data => {
            if (data.success) {
              this.emailValidMsg = data.statusCode;
              this.color = 'green';

              setTimeout("$('#userModal').modal('hide');", 1600);
              userForm.reset();
            } else {
              this.emailValidMsg = data.statusCode;
              this.color = 'red';
            }
          });


      } else {

        this.emailValidMsg = '211';

      }


    } else {

      const mailObj = {
        email_id: this.email_id,
        communityId: this.receiver,
        communityName: this.communityName
      };

      this.userService.unameRecoveryByEmailToAlignor(mailObj)
        .subscribe(data => {

          if (data.success) {
            this.emailValidMsg = data.statusCode;
            this.color = 'green';

            setTimeout("$('#userModal').modal('hide');", 1500);
            userForm.reset();
          } else {
            this.emailValidMsg = data.message;
            this.emailValidMsg = data.statusCode;
            this.color = 'red';
          }
        });

    }


  }

  setColor() {
    return this.color;
  }
  onChangeCommunityName(e) {
    this.first_name = "";
    this.last_name = "";
    this.email_id = "";
    this.emailValidMsg = "";

    for (let i = 0; i < this.AllCommunities.length; i++) {
      if (e.target.value == this.AllCommunities[i].comm_id) {
        this.communityName = this.AllCommunities[i].comm_name;
      }
    }

    this.userService.getSelectedCommunity(this.receiver)
      .subscribe(res => {
        if (res.data.privacy_protected == true) {
          this.emailProtected = false;
          this.noEmailProtected = true;
          this.recoverUsernameByName = true;
        } else {
          this.noEmailProtected = false;
          this.emailProtected = true;
          this.recoverUsernameByName = false;
        }
      });
  }


  clearServerValidation() {
    this.emailValidMsg = ""
  }
  clearValidData() {
    this.personalStstusCode = "";
    this.alignorStstusCode = "";

  }
  clearPopupData(userForm) {
    userForm.reset();
    this.emailProtected = true;
    this.noEmailProtected = true;
    this.receiver = undefined;
    // this.question = undefined;
  }

  clearValidUserData() {
    this.personalStstusCode = "";
    this.alignorStstusCode = "";
    this.userDataExistCode = '';
    this.uname_managedby = false;
    this.email_managedby = false;

  }

  playGame(numb) {
    if (numb == 1) {
      this.popupWindow = window.open(this.selectedGame['FREE_GAME_LINK_1'], 'Free Games', 'directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=970,height=640');
    } else {
      this.popupWindow = window.open(this.selectedGame['FREE_GAME_LINK_2'], 'Free Games', 'directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=970,height=640');
    }
  }

  getDisplayStyle(val) {
    let width = screen.width || window.screen.width;
    let height = screen.height || window.screen.height;
    this.screenWidth = width;
    this.screenHeight = height;

    if (width > 767 && height > 1000) {
      return val == 'display' ? 'block' : '100%';
    } else {
      return val == 'display' ? 'flex' : '';
    }
  }

  checkUserExist(userCheckForm) {
    this.userService.checkUserExist(this.user_name)
      .subscribe(res => {
        if (res.statusCode == 200) {
          this.userDataExistCode = 200;
          this.userExistData = res.data;
          this.email_id = this.userExistData.mail_id;
          this.question = this.userExistData.question;
          this.login_attempt = this.userExistData.login_attempt;
          this.need_security_que_reset = this.userExistData.need_security_que_reset;
          this.security_que_attempt = this.userExistData.security_que_attempt;

          if (this.email_id && this.need_security_que_reset) {
            this.dontShowSecurityQueRadio = true;
          } else if (this.email_id && !this.question) {
            this.dontShowSecurityQueRadio = true;
          } else {
            this.dontShowSecurityQueRadio = false;

          }
          if (this.userExistData.mail_id) {
            this.uname_managedby = false;
            this.email_managedby = true;
          } else {

            if (this.userExistData.question && this.userExistData.security_que_attempt > 2 && !this.userExistData.mail_id) {
              this.securityQueStatusCode = '204';
              $('#myModal').modal('hide');
              $('#securityQueResetModal').modal();
            } else if (!this.userExistData.question && this.userExistData.security_que_attempt > 2 && !this.userExistData.mail_id) {
              // this.securityAttemptMailToAdmin();
              this.securityQueStatusCode = '204';
              $('#myModal').modal('hide');
              $('#securityQueResetModal').modal();
            } else if (!this.userExistData.question && !this.userExistData.mail_id) {
              this.securityAttemptMailToAdmin();
              this.securityQueStatusCode = '204';
              // $('#myModal').modal('hide');
              // $('#securityQueResetModal').modal();
            }
            this.email_managedby = false;
            this.uname_managedby = true;
          }
        } else {
          this.uname_managedby = false;
          this.email_managedby = false;
          this.userDataExistCode = 201;
        }
      });
  }

  securityAttemptMailToAdmin() {
    this.userService.setSeqQues(this.user_name.toLowerCase(), false).
      subscribe(res => { console.log(res) });
    let mailObj = {
      user_name: this.user_name,
      isIsolated: false
    };
    this.userService.securityAttemptMailToAdmin(mailObj)
      .subscribe(data => {
        if (data.statusCode == 200) {
          this.answer = '';
          $('#myModal').modal('hide');
          $('#securityQueResetModal').modal();
        }
      }
      )
  }

  changePasswordType() {
    this.passwordType = !this.passwordType
  }
  ssoButtonRedirect() {
    this.showFrame = true;
    let comm_id = this.resAuth.comm_id;
    this.userService.getCognitoLinkFromSSObtn(comm_id)
      .subscribe(community => {
        if (community.success) {
          window.location.href = community.data.url;
        }
      });
  }

  gotoSocialSignIn(url) {
    // alert("In signin");
    var isSSOLogin = true;
    // var commID = this.resAuth.comm_id;
    // localStorage.setItem("commID", JSON.stringify(commID)); 
    localStorage.setItem("isSSOLogin", JSON.stringify(isSSOLogin));
    window.location.href = url;
  }

  gotoSocialSignUp(url) {
    // alert("In signup");
    var isSSOLogin = false;
    localStorage.setItem("isSSOLogin", JSON.stringify(isSSOLogin));
    window.location.href = url;
  }

  checkForSSOAUTH(comm_id: string, batch_id: string) {
    //  console.log('comm_id===>>',comm_id);
    if (comm_id) {

      //this.encodedUrl = value;
      this.userService.getCommunityNameByCommunityID(comm_id).subscribe(comm => {
        let commResObj = {
          community_id: comm.data.comm_id,
          community_name: comm.data.comm_name,
          resource_config: comm.data.resource_config,
          batch_id: batch_id
        };
        localStorage.setItem('CommResources', JSON.stringify(commResObj));

        let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

        let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
        let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

        this.globalService.setLang(lang_name);
        this.globalService.setLangId(lang_id);

        localStorage.setItem('defaultLangId', lang_id);
        localStorage.setItem('defaultLang', lang_name);

        this.translateService.use(lang_name);
        this.translateService.reloadLang(lang_name);
        this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
          'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
          'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
          'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
          'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
            this.buttonTitle = label;
          });

        if (comm.success && comm.data) {
          this.userService.getCommunityLogo(comm_id).subscribe(res => {
            let ob = { communityID: comm.data.comm_id };
            let gObj = {
              id: window.btoa(JSON.stringify(ob)),
              communityName: comm.data.comm_name,
              communityID: comm.data.comm_id,
              purpose: "login",
              image_data: res.data.image_data
            };
            this.globalService.isLoginComm = gObj;
            this.userService.isCommunity = window.btoa(JSON.stringify(ob));
            let comObj = {
              communityName: comm.data.comm_name,
              communityID: comm.data.comm_id,
              purpose: "login"
            };
            this.getclientData(window.btoa(JSON.stringify(comObj)));
          });
        }
      });
    }
    else {
      let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

      let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
      let lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

      this.globalService.setLang(lang_name);
      this.globalService.setLangId(lang_id);

      localStorage.setItem('defaultLangId', lang_id);
      localStorage.setItem('defaultLang', lang_name);

      this.translateService.use(lang_name);
      this.translateService.reloadLang(lang_name);
      this.translateService.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.NON_ALIGNORAUTH_USER', 'LOGIN_SERVER_MSG.DELETED_USER_MSG', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY', 'LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
        'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
        'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
        'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR', 'REGISTRATION.VALIDATION_MSG.DETAILS_NOT_MATCH', 'REGISTRATION.VALIDATION_MSG.EMAIL_NOT_MATCH',
        'REGISTRATION.VALIDATION_MSG.NAME_REQUIRED', 'LOGIN_SERVER_MSG.PERSONAL_REQUEST_SEND_SUCCESS', 'LOGIN_SERVER_MSG.USERNAME_MSG_SEND_SUCCESS']).subscribe(label => {
          this.buttonTitle = label;
        });

      this.globalService.isLoginComm = {
        id: null,
        communityName: null,
        communityID: null,
        purpose: null,
        image_data: null
      };
      this.userService.isCommunity = null;
      this.getclientData(null);
    }



  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/login/login.component.ts